module.exports = {
  '2-7': require('./2-7'),
  '5-card-draw': require('./5-card-draw'),
  'holdem': require('./holdem'),
  'stud': require('./stud'),
}
